/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ResourceRedirectService } from '@alfa-client/resource-redirect-shared';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ResourceUri } from '@ngxp/rest';

@Component({
  template: '',
})
export class ResourceRedirectComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly resourceRedirectService = inject(ResourceRedirectService);

  private readonly PARAM_URI: string = 'uri';
  private readonly PARAM_COLLABORATION_REQUEST_ID: string = 'collaborationRequestId';

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((queryParams: ParamMap) => {
      const resourceUri: ResourceUri = queryParams.get(this.PARAM_URI);
      if (resourceUri) {
        this.resourceRedirectService.redirectToResource(resourceUri, queryParams.get(this.PARAM_COLLABORATION_REQUEST_ID));
      }
    });
  }
}
